<div class="main-container">
  <h1>{{'404.title'|translate}}</h1>
  <a routerLink="/">{{'404.link' | translate}}</a>
</div>
